<template>
  <div class="bg">
    <mu-container class="wrap" @click="switchContentAll()">
      <h3 class="title">历年真题</h3>
      <div
        ref="content"
        :style="{ paddingBottom: isOverLimit ? 0 : '10px' }"
        :class="{ 'content-all': contentAll, content: isOverLimit }"
        class=""
      >
        {{ data.remark }}
      </div>

      <div v-if="isOverLimit" class="loader-more-wrapper">
        <mu-button icon small color="#9e9e9e">
          <mu-icon
            :value="contentAll ? 'arrow_drop_up' : 'arrow_drop_down'"
          ></mu-icon>
        </mu-button>
      </div>
    </mu-container>

    <mu-list class="list animated slideInUp">
      <mu-list-item
        v-for="item in data"
        :key="item.id"
        :ripple="false"
        :to="{
          path: '/mock-exam',
          query: {
            examination_id: item.id,
          },
        }"
        class="item"
        button
      >
        <mu-list-item-title>
          {{ item.title }}
        </mu-list-item-title>

        <mu-list-item-action>
          <mu-icon value="chevron_right"></mu-icon>
        </mu-list-item-action>
      </mu-list-item>
    </mu-list>
  </div>
</template>

<script>
import { getPassYearsList } from '@/api/index'

export default {
  components: {},
  data() {
    return {
      type: 1,
      isOverLimit: false,
      contentAll: false,
      data: {},
      info: {
        name: null,
        path: null,
      },
      breadcrumbsArr: [],
    }
  },

  beforeRouteUpdate() {
    console.log('beforeRouteUpdate')
    this.init()
  },
  mounted() {
    // this.type = this.$root.$data.navType
    this.type = Number(this.$route.query.type)
    this.init()
  },

  methods: {
    async init() {
      this.data = await getPassYearsList()
      this.type = 2
      this.$nextTick().then(() => {
        const ele = this.$refs.content
        this.isOverLimit = ele.offsetHeight >= 60
      })
    },
    switchContentAll() {
      this.contentAll = !this.contentAll
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  padding-bottom: 0;
}
.loader-more-wrapper {
  text-align: center;
  .mu-button {
    vertical-align: top;
  }
}
.content {
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 3; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}
.content-all {
  -webkit-line-clamp: unset;
  // box-shadow: 6px 12px 54px -13px rgba(0, 0, 0, 0.1);
}
</style>

<style lang="scss">
// 返回章节
.return-chapter {
  display: block;
  width: 45px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  z-index: 9;
}
</style>
